export const getters = {
  loggedIn: ({ loggedIn }) => loggedIn,
  user: ({ user }) => user,
};
